// Load postcode polygon GeoJSON files for selected countries.
// Files live under /data/ and are produced by scripts/prepare-data.mjs.

const cache = new Map();

const FILES = {
  DE: '/data/plz-de.geojson',
  AT: '/data/plz-at.geojson',
  CH: '/data/plz-ch.geojson',
  NL: '/data/plz-nl.geojson',
  BE: '/data/plz-be.geojson',
  LU: '/data/plz-lu.geojson',
  FR: '/data/plz-fr.geojson',
  DK: '/data/plz-dk.geojson',
  CZ: '/data/plz-cz.geojson',
  PL: '/data/plz-pl.geojson',
  CA: '/data/plz-ca.geojson',
  US: '/data/plz-us.geojson'
};

export async function loadPostcodes(countries) {
  const out = [];
  for (const c of countries) {
    const url = FILES[c];
    if (!url) continue;
    if (!cache.has(c)) {
      cache.set(c, fetch(url).then(async (r) => {
        if (!r.ok) throw new Error(`Failed to load postcodes for ${c}: ${r.status}`);
        const gj = await r.json();
        for (const f of gj.features) {
          f.properties = f.properties || {};
          f.properties.country = c;
          f.properties.plz = String(
            f.properties.plz ?? f.properties.postcode ?? f.properties.PLZ ?? f.properties.code ?? ''
          );
        }
        return gj.features;
      }).catch((e) => {
        cache.delete(c);
        throw e;
      }));
    }
    out.push(...(await cache.get(c)));
  }
  return out;
}

export function missingCountries(countries) {
  return countries.filter((c) => !FILES[c]);
}
